// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__20VLk","cards":"ClientCreditCards_cards__2ppV8","empty":"ClientCreditCards_empty__3Ycp-"};